import { usePurchaseComponents } from "@contexts/PurchaseComponentsContext";
import type { AxiosInstance } from "axios";

import { useQuery } from "@tanstack/react-query";

import type { BoosterMultipliersResponse } from "./types";

const BOOSTER_MULTIPLIERS_PATH = "/v1/purchase/booster/multipliers";
const BOOSTER_MULTIPLIERS_QUERY_KEY = "booster-multipliers";

const fetchBoosterMultipliers = async (
  apiClient: AxiosInstance,
  aviosAmount: number,
): Promise<BoosterMultipliersResponse> => {
  const { data } = await apiClient.get<BoosterMultipliersResponse>(BOOSTER_MULTIPLIERS_PATH, {
    params: { aviosAmount },
  });

  return data;
};

const getBoosterMultipliersQuery = (apiClient: AxiosInstance, aviosAmount: number, enabled = true) => ({
  queryKey: [BOOSTER_MULTIPLIERS_QUERY_KEY, aviosAmount, apiClient],
  queryFn: () => fetchBoosterMultipliers(apiClient, aviosAmount),
  enabled: enabled && aviosAmount > 0,
});

/** Fetches booster multiplier options for the given Avios amount. */
export const useBoosterMultipliers = (aviosAmount: number, enabled = true) => {
  const { apiClient } = usePurchaseComponents();

  return useQuery(getBoosterMultipliersQuery(apiClient, aviosAmount, enabled));
};
